<template>
  <div>
    <b-modal class="popup-message"
      scrollable
      centered
      v-for="(item, i) in messages"
      :key="i"
      :ref="'modal' + i"
      content-class="message-login-popup"
    >
      <template #modal-header="{ close }">
        <span class="text-center w-100 px-3">{{ item.title }}</span>
        <b-icon style="cursor: pointer;" icon="x" @click="close"></b-icon>
      </template>
      <div class="message-popup">
        <b-img v-if="item.photo" class="pb-3 w-100" height="250px" :src="item.photo">
        </b-img>
        <div class="pb-3 content" v-html="item.content"></div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button @click="cancel" variant="primary" class="m-auto">{{
          $t("adv-close-btn")
        }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.message-popup {
  height: 450px;
  max-height: 450px;
  img {
    object-fit: cover;
  }
  .content {
    white-space: break-spaces;
    overflow-wrap: break-word;
    word-break: break-word;   
  }

  
}
::v-deep {
  .message-login-popup {
    .media div {
     width: 400px;
    height: 200px;
    }
  }
  
}

</style>

<script>
import messageService from "@/services/messageAfterLogin";
import dateMixin from "@/mixins/date";
import { MESSAGE_POPUP_CONDITION, USER_TYPE } from "../../constants/home";
export default {
    // props: ['msgType', 'userType'],
    mixins: [dateMixin],
    data() {
        return {
            messages: [],
        }
    },
    computed: {
        formatMessage() {
        return this.messages.map((item)=> {
        var div = document.createElement('div');

        // assing your HTML to div's innerHTML
          div.innerHTML = item.content;
        // get all <a> elements from div
        let elements = div.getElementsByTagName('a');
        let arr = Array.prototype.slice.call( elements);
        if(arr.length > 0) {
          arr.map((ele)=> {
          if(ele.href && ele.href.includes('{pkAdv}')) {
           ele.href = ele.href.replace('{pkAdv}', JSON.parse(localStorage.getItem('user')).pkAdv);
            ele.innerHTML = ele.innerHTML.replace('{pkAdv}', JSON.parse(localStorage.getItem('user')).pkAdv)

          }

          if(ele.href && ele.href.includes('{pkCrf}')) {
           ele.href =  ele.href.replace('{pkCrf}', JSON.parse(localStorage.getItem('user')).pkCrf);
           ele.innerHTML =  ele.href.replace('{pkCrf}', JSON.parse(localStorage.getItem('user')).pkCrf)

          }
          })
        }
         item.content = div.innerHTML;
         return item
          })
        },
        popupShownArr() {
            return localStorage.getItem('isPopupShown') ? JSON.parse(localStorage.getItem('isPopupShown')) : {};
        },
        userInfo() {
            return JSON.parse(localStorage.getItem('user'));
        },
        isExAdv () {
          return this.userInfo.isEmployee && this.userInfo.applicationStatus === 13;
        },
        isCandidate () {
          return !this.userInfo.isEmployee || this.isExAdv;
        },
        userTypeCondition() {
          let userType = '';
          if (this.isExAdv) {
            userType = 'ex_adv';
          } else if (this.isCandidate) {
            userType = 'adv_candidate';
          } else if (!this.isCandidate) {
            userType = 'current_adv';
          }
          return userType;
        }
    },
    created() {
        this.getAllMessagePopup();
    },
    methods: {
        showMsgCondition(mess) {
            const showOnceCondition = mess.type == MESSAGE_POPUP_CONDITION.SHOW_ONCE ?
                (!this.popupShownArr[this.userInfo.pkAdv] || !this.popupShownArr[this.userInfo.pkAdv].includes(mess.id))
                : true;
            return mess.receiver.includes(this.userTypeCondition)
            && this.userTypeCondition
            && showOnceCondition
            && this.isActiveDate(mess.startTime, mess.endTime)
            && mess.isActive;
        },
        getAllMessagePopup() {
          messageService
            .getAllMessage({limit: 100})
            .then(res => {
              if (res.messages.length) {
                res.messages.reverse();
                res.messages.forEach((mess, i) => {
                  if (this.showMsgCondition(mess)) {
                    const showMessage = (msg) => {
                      this.messages.push(msg);
                      
                      setTimeout(() => {
                        this.messages = this.formatMessage;
                        this.messages.forEach((item, index) => {
                          const ref = 'modal' + index;
                          this.$refs[ref][0].show();
                        })
                      }, 1500);
                    }
                    if (mess.type == MESSAGE_POPUP_CONDITION.SHOW_ONCE) {
                      if (!this.popupShownArr[this.userInfo.pkAdv]) {
                        this.popupShownArr[this.userInfo.pkAdv] = [mess.id];
                      } else {
                        this.popupShownArr[this.userInfo.pkAdv].push(mess.id);
                      }
                      localStorage.setItem('isPopupShown', JSON.stringify(this.popupShownArr));
                    }
                    if (mess.PictureId) {
                       const appBaseUrl =   window.configs && window.configs.VUE_APP_ROUTE_BASE_URL !== "" 
                        ? window.configs.VUE_APP_CHAT_URL: process.env.VUE_APP_ROUTE_BASE_URL
                        ? process.env.VUE_APP_ROUTE_BASE_URL
                        : "https://advportalapi.vita.ovh";
                      mess.photo = `${appBaseUrl}/api/v2/documents/download/${mess.PictureId}`;
                    }
                    showMessage(mess);
                  }
                });
              }
            });
        },
    }
}
</script>